/**
 * Firebase Configuration Utility
 *
 * Extracts and validates Firebase config from Vite environment variables.
 * Shared across push notification context and profile page.
 *
 * @module utils/firebaseConfig
 */

import { env } from '../config/env';

/**
 * Build Firebase config from Vite env vars.
 * Returns empty object if not configured (local dev without Firebase).
 */
export function getFirebaseConfig(): Record<string, string> {
  return {
    ...(env.VITE_FIREBASE_API_KEY && { apiKey: env.VITE_FIREBASE_API_KEY }),
    ...(env.VITE_FIREBASE_AUTH_DOMAIN && { authDomain: env.VITE_FIREBASE_AUTH_DOMAIN }),
    ...(env.VITE_FIREBASE_PROJECT_ID && { projectId: env.VITE_FIREBASE_PROJECT_ID }),
    ...(env.VITE_FIREBASE_STORAGE_BUCKET && { storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET }),
    ...(env.VITE_FIREBASE_MESSAGING_SENDER_ID && { messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID }),
    ...(env.VITE_FIREBASE_APP_ID && { appId: env.VITE_FIREBASE_APP_ID }),
  };
}
